<div class="problem-info__wrapper">
    <mat-card>
        <mat-card-title>Przepraszamy wystąpił problem</mat-card-title>
        <p class="problem-info">Prosimy spróbować później, lub skontaktować się z recepcją.</p>
        <mat-card-actions align="center" class="mb-2"> 
          <button  color="primary" mat-raised-button (click)="redirectNewRes()">Spróbuj ponownie</button>
        </mat-card-actions>
      </mat-card>
</div>